import styled from 'styled-components';

import { Cell, Table } from 'components/ui/StyledTable';

export const VatBreakdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px 16px;
`;

export const VatAddresses = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 16px 16px 16px;
  gap: 8px;

  & > small:empty {
    display: none;
  }
`;

export const StyledPassengerName = styled.h2`
  margin-top: 8px;
  margin-bottom: 4px;
`;

export const StyledTable = styled(Table)`
  box-shadow: none;
  padding: 0;
  margin-bottom: 16px;
`;

export const StyledCell = styled(Cell)`
  padding: 4px 8px;
`;
